import { Component, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { CantinaService } from 'src/app/_servizi/cantina.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';
import { StripeService } from 'src/app/_servizi/stripe.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-sezioni-tipi-visite',
  templateUrl: './sezioni-tipi-visite.component.html',
  styleUrls: ['./sezioni-tipi-visite.component.css']
})
export class SezioniTipiVisiteComponent implements OnInit, OnDestroy {

  observer!: ResizeObserver;

  checkAbilitato = false;
  abilitato = false;
  nonabilitatoMsg = '';

  codiceForm: any;
  linguaCorrente: string;
  layout: number;
  sezione: number;
  carrello: boolean;

  tipivisite: any[] = [];

  loading = false;

  constructor(
    private messageService: MessageServiceService,
    private host: ElementRef,
    private zone: NgZone,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private adapter: DateAdapter<any>,
    private cantinaService: CantinaService,
    private appoggioService: AppoggioService,
    private stripeService: StripeService
  ) { }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params) => {

      this.codiceForm = params.get('cantina');
      this.linguaCorrente = params.get('lingua');
      this.sezione = parseInt(params.get('sezione'));
      this.layout = parseInt(params.get('layout'));
      this.carrello = params.get('cart') === '1' ? true : false;

      this.translate.use(this.linguaCorrente);
      this.adapter.setLocale(this.translate.currentLang);

      this.controllaCantina(this.codiceForm);

      let idCookie = params.get('idCookie');

      if (idCookie && idCookie !== 'null') {
        this.messageService.setIdCookie(idCookie);
      } else {
        idCookie = uuidv4();
        this.messageService.sendIdCookie(idCookie);
        this.messageService.setIdCookie(idCookie);
      }
    });

    this.observer = new ResizeObserver(entries => {
      this.zone.run(() => {
        this.messageService.sendHeighMessage(entries[0].contentRect.height);
      });
    });
    this.observer.observe(this.host.nativeElement);

  }
  ngOnDestroy(): void {
    this.observer.unobserve(this.host.nativeElement);
  }

  controllaCantina(codiceForm): void {
    this.loading = true;
    this.cantinaService.getStato(codiceForm)
      .subscribe(cantina => {
        this.checkAbilitato = true;
        if (cantina && cantina.length > 0) {
          const clientUrl = document.referrer;
          this.abilitato = true;

          this.appoggioService.setCodiceForm(codiceForm);

          if (cantina[0]['infoStripe'] != null) {
            const infoStripe = {
              abilitatoAccount: cantina[0]['infoStripe']['abilitatoAccountStripe'] === '1' ? true : false,
              abilitatoProduzione: cantina[0]['infoStripe']['abilitatoProduzione'] === '1' ? true : false,
              api_key: cantina[0]['infoStripe']['abilitatoProduzione'] === '1' ? cantina[0]['infoStripe']['apiKeyStripeProduzione'] : cantina[0]['infoStripe']['apiKeyStripeTest'],
              endpoint_secret: cantina[0]['infoStripe']['abilitatoProduzione'] === '1' ? cantina[0]['infoStripe']['endpointSecretProduzione'] : cantina[0]['infoStripe']['endpointSecretTest']
            }
            this.stripeService.setInfoStripe(infoStripe);
          } else {
            this.stripeService.setInfoStripe(null);
          }

          this.appoggioService.setColoriIframe(cantina[0]);

          this.cantinaService.getTipoVisiteBySezione(codiceForm, this.linguaCorrente, this.sezione)
            .subscribe(tipovisite => {
              this.tipivisite = tipovisite;
            });

        } else {
          this.abilitato = false;
          this.nonabilitatoMsg = 'nonAbilitato';
        }
        setTimeout(() => {
          this.loading = false;
        }, 2000)
      });
  }
  // emettiClick(tipovisitaId: number): void {
  //   this.messageService.sendClickMessage(this.codiceForm, tipovisitaId, this.linguaCorrente);
  // }
}

